import {createTheme} from "@mui/material"

// <html> is at 62.5 % (styles/base.scss): 1rem = 10px. MUI converts its sizes to rem on a 16px basis by default,
// htmlFontSize tells it the real basis. To be used by every MUI theme: createTheme(muiThemeOptions, {...}).
export const muiThemeOptions = {
    typography: {
        htmlFontSize: 10,
    },
}

export const muiTheme = createTheme(muiThemeOptions)
